<template>
  <div>
    <div v-if="!loading" class="home-pag modern-profile-wrapper">
      <banner title="Profile"></banner>
      <div>
        <section class="event team-sec team-grid speaker set-relative" id="speaker">
          <div class="container">
            <div class="row">
              <div class="col-lg-10 offset-lg-1 col-md-12 speaker-container">
                <div style="display: flex;" class="flex-column flex-md-row">
                    <div style="display: flex;" class="row flex-wrap align-items-baseline h-100">
                    <div class="col-12 text-center">
                      <div class="row mx-auto">
                        <div class="col-auto mx-auto">
                         <!--  <ImageCropUpload
                          ref="imageCropper"
                          :existingImage="photoLink"                          
                          buttonLabel="Upload Photo"
                          :size="200"
                          :cropSize="300"
                          :maxSizeKB="200"
                          @uploaded="handlePhotoUpload"
                          @heightChange="updateInfoMargin"
                          :photoEditable="photoEditable"
                        /> -->

                        <ImageUploadModal
                          :existingImage="photoLink"
                          buttonLabel="Upload Photo"
                          :size="200"
                          :maxSizeKB="200"
                          :requiredWidth="300"
                          :requiredHeight="300"
                          :photoEditable="profileEditable"
                          @uploaded="handlePhotoUpload"
                        />

                      <!--
                      <img alt="" style="max-width:13rem; border: 1px solid lightgray;" class="p-1 img-fluid" :src="photoLink">
                      -->
                        </div>
                      </div>
                      <div class="row mx-auto">
                        <div class="col-auto mt-3 mx-auto">
                        <SignatureUploadModal
                          :existingImage="signatureLink"
                          buttonLabel="Upload Signature"
                          :displayWitdh="200"
                          :displayHeight="30"
                          :maxSizeKB="150"
                          :requiredWidth="300"
                          :requiredHeight="80"
                          :signatureEditable="profileEditable"
                          @uploaded="handleSignatureUpload"
                        />
                        </div>
                      </div>
                      
                    </div>
                    <div class="row" :style="{ marginTop: infoMargin + 'px' }">
                      <div class="col-12" style="max-width:13rem; margin: 0 auto;">
                        <div class="checkout-page" style="max-width:13rem;padding-top:10px">
                          <div class="checkout-form theme-form">
                            <h6 style="color:#3e467d">{{registrationForm.name}}</h6>
                            <h6 style="margin-top: 10px;color: rgb(101 105 134);text-transform:unset">UserID : {{registrationForm.userID}}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="row" v-if="personTab"> -->
                      <!--
                      <div v-if="photoEditable!=0 && !imageUploading" class="custom-file b-form-file" style="max-width: 15rem; margin-top: 15px;" id="__BVID__16__BV_file_outer_">
                        <input type="file" id="actual-btn" ref="file" v-on:change="imageUpload()" hidden/>
                        <label for="actual-btn" id="labelImgBtn"><i class="fa fa-upload"></i> {{photoEditBtnTxt}}</label>
                        <div style="margin-top:10px;padding:2px;font-size:13px" id="photoAlert" class="alert alert-info dark fade show" role="alert">
                          Max Size:{{photoInfo.maxSize}}KB,Exact resolution W:{{photoInfo.width}}px,H:{{photoInfo.height}}px
                        </div>
                      </div>

                      <div v-if="imageUploading" class="custom-file b-form-file" style="max-width: 15rem; margin-top: 15px;display:none;">
                        <input type="file" id="actual-btn" ref="file" v-on:change="imageUpload()" hidden/>
                        <label for="actual-btn" id="labelImgBtn"><i class="fa fa-upload"></i> {{photoEditBtnTxt}}</label>
                        <div style="margin-top:10px;padding:2px;font-size:13px" id="photoAlert" class="alert alert-info dark fade show" role="alert">
                          Max Size:{{photoInfo.maxSize}}KB,Exact resolution W:{{photoInfo.width}}px,H:{{photoInfo.height}}px
                        </div>
                      </div>
                    -->
                    <!-- </div> -->


                    
               


                  </div>
                  
                  <div class="employee modern-tabs-wrapper" style="-webkit-box-shadow:unset;box-shadow:unset">
                    <b-tabs content-class="modern-tab-content" pills card>
                      <b-tab @click="tabChange('person')" v-if="!showStillInterested" :active="!showStillInterested" title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-user"></i>
                          <span class="tab-text">Personal</span>
                        </template>
                        <profile-personal
                          :registrationForm="registrationForm"
                          :profileEditable="profileEditable"
                          :pQuota="pQuota"
                          :onlyPCQPersonal="onlyPCQPersonal"
                          :isPButtonLoading="isPButtonLoading"
                          :isPButtonLoadingClass="isPButtonLoadingClass"
                          :openExam="openExam"
                          :closePaymentSlip="closePaymentSlip"
                          :openCorrection="openCorrection"
                          :closeCorrection="closeCorrection"
                          :photoEditable="photoEditable"
                          :dew="dew"
                          @submit="onSubmit"
                          @payment-slip="onApplicationPaySlip"
                        />
                      </b-tab>

                      <b-tab @click="tabChange('academic')" v-if="!closeResult" title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-graduation-cap"></i>
                          <span class="tab-text">Academic</span>
                        </template>
                        <profile-academic-info></profile-academic-info>
                      </b-tab>

                      <b-tab @click="tabChange('application')" v-if="(saveProfile && hasPhoto && !pQuota && !openSubjectChoice)" title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-file-text"></i>
                          <span class="tab-text">Application</span>
                        </template>
                        <profile-application
                          :applicationForm="applicationForm"
                          :units="units"
                          :unitObj="unitObj"
                          :quotas="quotas"
                          :applicationApplicable="applicationApplicable"
                          :onApplicationLoading="onApplicationLoading"
                          :closeCall="closeCall"
                          :onlyPCQApplication="onlyPCQApplication"
                          :isAButtonLoading="isAButtonLoading"
                          :isAButtonLoadingClass="isAButtonLoadingClass"
                          :openCall="openCall"
                          :closeAdmitCard="closeAdmitCard"
                          :openAdmitCard="openAdmitCard"
                          :closePaymentSlip="closePaymentSlip"
                          :isPayButtonLoading="isPayButtonLoading"
                          :isPayButtonLoadingClass="isPayButtonLoadingClass"
                          @application-submit="onApplicationSubmit"
                          @unit-change="getUnitValues"
                          @payment-slip="onApplicationPaySlip"
                          @admit-card="showAdmitCard"
                          @bkash-payment="startBkashCheckoutService"
                          @rocket-payment="startDbblRocketPayment"
                          @visa-payment="startDbblVisaPayment"
                          @mastercard-payment="startDbblMasterCardPayment"
                        />
                      </b-tab>

                        <!-- <b-tab @click="tabChange('correction')" v-if="openCorrection && !closeCorrection && (!photoEditable && !profileEditable) && registrationForm.bill_status!='assigned'" title-link-class="modern-tab-link">-->
                      <b-tab @click="tabChange('correction')" v-if="(openCorrection && !closeCorrection && (!photoEditable && !profileEditable))" title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-edit"></i>
                          <span class="tab-text">Correction</span>
                        </template>
                        <profile-correction
                          :correctionForm="correctionForm"
                          :registrationForm="registrationForm"
                          :correctionApplied="correctionApplied"
                          :isLoading="isCorrectionLoading"
                          :isPayButtonLoading="isPayButtonLoading"
                          :closePayment="closeCorrectionPayment"
                          :paidCorrectionBills="paidCorrectionBills"
                          :closePaymentSlip="closePaymentSlip"
                          @apply-correction="onApplyForCorrection"
                          @bkash-payment="startBkashCorrectionPayment"
                          @rocket-payment="startDbblRocketCorrectionPayment"
                          @visa-payment="startDbblVisaCorrectionPayment"
                          @mastercard-payment="startDbblMasterCardCorrectionPayment"
                          @correction-payment-slip="onCorrectionPaySlip"
                        />
                      </b-tab>

                      <b-tab title="Seat Plan" v-if="(openSeatPlan && applicationInfoLoaded && !closeSeatPlan)" title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-map-marker"></i>
                          <span class="tab-text">Seat Plan</span>
                        </template>
                        <profile-seat-plan :applications=applications></profile-seat-plan>
                      </b-tab>
                      <b-tab title="Seat Plan" disabled v-else-if="0 && closeCorrectionPayment && !applicationInfoLoaded && !closeSeatPlan" title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-map-marker"></i>
                          <span class="tab-text">Seat Plan</span>
                        </template>
                      </b-tab>

                      <b-tab title="Exam Result" v-if="(openResult && !closeResult)" title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-trophy"></i>
                          <span class="tab-text">Exam Result</span>
                        </template>
                        <profile-result :applications=applications></profile-result>
                      </b-tab>
                      <b-tab title="Exam Result" v-else-if="0 && closeResult" disabled title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-trophy"></i>
                          <span class="tab-text">Exam Result</span>
                        </template>
                      </b-tab>

                      <b-tab title="Subject Selection" v-if="(openSubjectChoice && (1 || !closeSubjectChoice))" title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-list-alt"></i>
                          <span class="tab-text">Subject Selection</span>
                        </template>
                        <profile-subject-selection :applications=applications></profile-subject-selection>
                      </b-tab>
                      <b-tab title="Subject Selection" v-else-if="0 && profileWindow>2" disabled title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-list-alt"></i>
                          <span class="tab-text">Subject Selection</span>
                        </template>
                      </b-tab>

                      <b-tab title="SIF" v-if="(openSif && (1 || !closeSif))" title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-pencil-square-o"></i>
                          <span class="tab-text">SIF Fillup</span>
                        </template>
                        <profile-sif></profile-sif>
                      </b-tab>
                      <b-tab title="SIF" v-else-if="0  && openSubjectChoice" disabled title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-pencil-square-o"></i>
                          <span class="tab-text">SIF Fillup</span>
                        </template>
                      </b-tab>

                      <b-tab title="stillInterested" v-if="showStillInterested" :active="showStillInterested" title-link-class="modern-tab-link">
                        <template #title>
                          <i class="fa fa-check-circle"></i>
                          <span class="tab-text">Still Interested?</span>
                        </template>
                        <profile-still-interested></profile-still-interested>
                      </b-tab>

                    </b-tabs>
                  </div>
                </div>
                <!-- <div class="col-lg-10 offset-lg-1 col-md-12 speker-container"> v-if="personTab"-->
                <!-- <div v-if="personTab" class="d-flex" style="margin-top:35px;max-height: 336px;overflow-y: auto;">
                  <div class="row" style="padding:15px">
                    <div class="col-md-12">
                      <h5 style="margin-bottom:15px;width:100%" class="breadcrumb-txt" >User Access Log</h5>
                    </div>
                    <div class="col-md-12">
                      <table class="table cart-table table-responsive-xs">
                        <thead>
                          <tr class="table-head">
                            <th scope="col">Activities</th>
                            
                            <th scope="col">Access Time</th>
                            <th scope="col">Source IP</th>
                          </tr>
                        </thead>
                        <tbody> 
                          <tr v-for="activityLog in activityLogs" :key="activityLog.id">
                            <td>
                              {{activityLog.activity}}
                            </td>
                            <td>
                              {{activityLog.access_time}}
                            </td>
                            <td>
                              {{activityLog.host_ip}}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div> -->
                <!-- </div> -->
                <div class="modern-application-status-wrapper" style="margin-top:35px;">
                  <div class="row" style="padding:15px">
                    <div class="col-md-12">
                      <div class="status-table-header">
                        <h4 class="status-table-title">
                          <i class="fa fa-list-alt"></i> Application Status
                        </h4>
                        <p class="status-table-subtitle">Track your application submissions and payment status</p>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="px-0 modern-table-wrapper">
                        <table class="modern-status-table col-12 px-0 rounded">
                          <thead>
                            <tr>
                              <th><i class="fa fa-university"></i> Unit/Sub-unit</th>
                              <th><i class="fa fa-file-text"></i> Bill Number</th>
                              <th><i class="fa fa-credit-card"></i> Payment Method</th>
                              <th><i class="fa fa-receipt"></i> Payment Slip</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="application in applications" :key="application.id" v-if="application.bill_number">
                              <td>
                                <div class="unit-badge">{{application.unit}}</div>
                              </td>

                              <td>
                                <span class="bill-number">{{application.bill_number.bill_number}}</span>
                              </td>
                              <td>
                                <div class="payment-method-badge">
                                  <i class="fa fa-check-circle" style="color: #10b981;"></i>
                                  {{application.bill_number.transaction_agent}}
                                </div>
                              </td>
                              <td>
                                <!-- <button v-if="application.bill_number.bill_number!='' && !closePaymentSlip" class="modern-slip-button" type="button" @click="showPaymentSlip(application.unit,application.bill_number.status,application.status,application.bill_number.bill_number,application.bill_number.transaction_agent,application.bill_number.fee,application.bill_number.paid_at)">
                                  <i class="fa fa-download"></i> View Slip
                                </button> -->


                                <button 
                                    class="btn info-btn btn-info radius-1 align-items-center" 
                                    @click="downloadPaySlip({
                                      unit:application.unit,
                                      bill_status:application.bill_number.status,
                                      application_status:application.status,
                                      bill_number:application.bill_number.bill_number,
                                      agent:application.bill_number.transaction_agent,
                                      amount:application.bill_number.fee,
                                      paid_at:application.bill_number.paid_at
                                    })"
                                    :disabled="downloadingBills[application.bill_number.bill_number]"
                                    type="button"
                                  >
                                    <!-- Icon -->
                                    <i 
                                      :class="downloadingBills[application.bill_number.bill_number] ? 'fa fa-spinner fa-spin' : 'fa fa-download'" 
                                      aria-hidden="true"
                                      style="font-size: 1.2em; margin-right: 8px;"
                                    ></i>

                                    <!-- Text -->
                                    <span style="font-size: 0.85rem;">
                                      {{ downloadingBills[application.bill_number.bill_number] ? paySlipProgresse : 'Download Payment Receipt' }}
                                    </span>
                                  </button>



                              </td>
                            </tr>
                            <tr v-if="!applications || applications.length === 0">
                              <td colspan="4" class="empty-state">
                                <div class="empty-state-content">
                                  <i class="fa fa-inbox"></i>
                                  <p>No applications found</p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>      
      </div>
      <b-modal id="applicationClaimModal" size="lg" hide-footer>
        <template #modal-title>
          Claim Process
        </template>
        
        <b-button class="mt-3" @click="$bvModal.hide('applicationClaimModal')" block >Click here to Hide</b-button>
        <!-- @click="$bvModal.hide('bv-modal-example')" -->
      </b-modal>
      <b-modal id="applicationPaySlip" size="lg" hide-footer>
        <template #modal-title>
          Payment Slip
        </template>
        <div class="row" ref="testHtml" style="padding:15px;padding-top:25px;max-width:601px;margin:auto;">
        
          <div class="col-md-12" ref="content1" id="content1" style="margin-bottom:15px;text-align:center">
            <img alt="" style="width:55px;margin-bottom:5px" class="img-fluid" src="../../theme-assets/images/logo/cu_logo.png">
            <h4 align="center" style="text-transform: unset;">University of Chittagong</h4>
            <h5 align="center"> Admission Test 2025-2026</h5>
            <hr style="height:4px">
          </div>
          <!-- <div class="col-md-2"></div> -->
          <div class="col-md-12">
            <h6 style="margin-bottom:10px" align="center">Pay Slip</h6>

            <table style="margin:auto;">
                <tr>
                    <td class="count-desc">Applicant's Name:</td>
                    <td class="count-desc">{{registrationForm.name}}</td>
                </tr>
                <tr>
                    <td class="count-desc">Father's Name:</td>
                    <td class="count-desc">{{registrationForm.father_name}}</td>
                </tr>
                <tr>
                    <td class="count-desc">Mother's Name:</td>
                    <td class="count-desc">{{registrationForm.mother_name}}</td>
                </tr>
                <tr>
                    <td class="count-desc">User ID:</td>
                    <td class="count-desc">{{registrationForm.userID}}</td>
                </tr>

                <tr>
                    <td class="count-desc">{{paymentSlipInfo.unit.charAt(1) ? 'Sub-Unit':'Unit'}}:</td>
                    <td class="count-desc">{{paymentSlipInfo.unit}}</td>
                </tr>
                <tr>
                    <td class="count-desc">Bill Number:</td>
                    <td class="count-desc">{{paymentSlipInfo.bill_number}}</td>
                </tr>
                <tr>
                    <td class="count-desc">Fee:</td>
                    <td class="count-desc">{{paymentSlipInfo.amount}}</td>
                </tr>
                <tr>
                    <td class="count-desc">Payment Status:</td>
                    <td class="count-desc" style="text-transform: capitalize;" v-if="paymentSlipInfo.bill_status=='confirmed'">Paid</td>
                    <td class="count-desc" style="text-transform: capitalize;" v-else>{{paymentSlipInfo.bill_status}}</td>
                </tr>
                <tr>
                    <td class="count-desc">Payment Date & Time:</td>
                    <td class="count-desc">{{paymentSlipInfo.paid_at}}</td>
                </tr>
                <tr>
                    <td class="count-desc">Payment Method:</td>
                    <td class="count-desc">{{paymentSlipInfo.agent}}</td>
                </tr>
            </table>
            
          </div>
        </div>
        <b-button class="mt-3" @click="generatePdf" block >Click here to Download</b-button>
        <!-- @click="$bvModal.hide('bv-modal-example')" -->
      </b-modal>


      <!-- DBBL Rocket Payment Failure Modal -->
      <b-modal id="rocketPaymentFailureModal" size="lg" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close>
        <template #modal-title>
          <i class="fa fa-times-circle" style="color: red;"></i> Rocket Payment Failed
        </template>
        <div class="row" style="padding:15px;padding-top:25px;max-width:601px;margin:auto;">
          <div class="col-md-12" style="margin-bottom:15px;text-align:center">
            <img alt="" style="width:55px;margin-bottom:5px" class="img-fluid" src="../../theme-assets/images/logo/cu_logo.png">
            <h4 align="center" style="text-transform: unset;">University of Chittagong</h4>
            <h5 align="center">Admission Test 2025-2026</h5>
            <hr style="height:4px">
          </div>
          <div class="col-md-12">
            <div class="alert alert-danger" role="alert">
              <h5 class="alert-heading">Payment Failed</h5>
              <p>Unfortunately, your DBBL Rocket payment could not be completed.</p>
            </div>
            <h6 style="margin-bottom:15px;margin-top:20px"><strong>Error Details:</strong></h6>
            <div class="alert alert-warning" role="alert">
              <strong>Reason:</strong> {{dbblPaymentError.reason}}
              <div v-if="dbblPaymentError.code" style="margin-top:10px">
                <strong>Error Code:</strong> {{dbblPaymentError.code}}
              </div>
            </div>
            <div class="alert alert-info" role="alert">
              <strong>What to do next:</strong>
              <ul style="margin-top:10px;margin-bottom:0">
                <li>Please try again after some time</li>
                <li>Ensure you have sufficient balance in your DBBL Rocket account</li>
                <li>If the problem persists, contact the helpdesk</li>
                <li>Reference this error message when contacting support</li>
              </ul>
            </div>
          </div>
        </div>
        <b-button class="mt-2" variant="primary" @click="retryPayment" block>
          <i class="fa fa-refresh"></i> Try Again
        </b-button>
        <b-button class="mt-2" variant="secondary" @click="closePaymentModal" block>Close</b-button>
      </b-modal>
    </div>
    <div v-else>
      <loader class="loader"></loader> <br />
      <!-- <h4 class="text-center">...... Loading ......</h4> -->
    </div>
    <div class="tap-top">
      <div><i v-on:click="topFunction()" class="fa fa-angle-double-up"></i></div>
    </div>
  </div>
</template>

<script>
import Loader from '../Helper/Loader'
import Banner from '../Partial/Banner'
import { GET_STUDENT_PROFILE_PERSONAL, UPDATE_STUDENT_PROFILE_PERSONAL, GET_HSC_BOARDS, GET_SSC_BOARDS, GET_YEARS, GET_QUOTAS, GET_UNITS, UPLOAD_PHOTO, GET_REQUEST_CHANGE, GET_PAID_CORRECTION_BILLS, GET_APPLICATION_BY_UNIT, PROCESS_APPLICATION, GET_REQUEST_APPLICATION_CHANGE, GET_STUDENT_PROFILE_APPLICATION, BKASH_PAYMENT_GATEWAY, DBBL_PAYMENT_GATEWAY } from '../../const/api'
import { GET, POST } from '../../utils/Request'
import { generateReceipt, prepareReceiptDataFromLegacy, RECEIPT_PRESETS } from '../../utils/ReceiptGenerator'

import ProfilePersonal from './ProfilePersonal.vue'
import ProfileApplication from './ProfileApplication.vue'
import ProfileCorrection from './ProfileCorrection.vue'
import ProfileSeatPlan from './ProfileSeatPlan.vue'
import ProfileResult from './ProfileResult.vue'
import ProfileAcademicInfo from './ProfileAcademicInfo.vue'
import ProfileSubjectSelection from './ProfileSubjectSelection.vue'
import ProfileSif from './ProfileSif.vue'
import ProfileStillInterested from './ProfileStillInterested.vue'

//import ImageCropUpload from "../Helper/ImageCropUpload.vue"
import ImageUploadModal from "../Helper/ImageUploadModal"
import SignatureUploadModal from '../Helper/SignatureUploadModal'
import PayslipGenerator from '@/utils/PayslipGenerator'

export default {
  name: 'Profile',
  components: { Loader, Banner, ProfilePersonal, ProfileApplication, ProfileCorrection, ProfileSeatPlan, ProfileResult, ProfileAcademicInfo, ProfileSubjectSelection, ProfileSif, ProfileStillInterested, ImageUploadModal,SignatureUploadModal },
  data() {
    return {
      infoMargin: 20, // default spacing
      loading: true,
      profileWindow:1,

      imageUploading:false,
      onApplicationLoading:false,
      firstTimeLoad: true,
      saveProfile: false,
      hasPhoto: false,
      applicationEnable:false,
      isPButtonLoading:false,
      isPButtonLoadingClass:'',
      isAButtonLoading:false,
      isAButtonLoadingClass:'',
      isPayButtonLoading:false,
      isPayButtonLoadingClass:'',

      photoLink:process.env.VUE_APP_API_URL+'/dist/img/avatar.png',
      signatureLink:process.env.VUE_APP_API_URL+'/dist/img/signature.png',
      iconLink:process.env.VUE_APP_API_URL+'/dist/img/BKashIcon.svg',
      /*pdfLink:process.env.VUE_APP_API_URL+'/dist/pdf/sample.pdf',*/
      
      openCall: false,
      closeCall: false,
      
      openCallPayment: false,
      closeCallPayment: false,

      openCorrection: false,
      closeCorrection: false,
      
      openCorrectionPayment: false,
      closeCorrectionPayment: false,

      openPaymentSlip: false,
      closePaymentSlip: false,
      
      openAdmitCard: false,
      openAdmitCardDate: '',
      openAdmitCardMsg: '',
      closeAdmitCard: false,

      openExam: false,
      closeExam: false,
      
      openResult: false,
      openResultDate: '',
      openResultMsg: '',
      closeResult: false,
      
      openSeatPlan: false,
      openSeatPlanDate: "",
      openSeatPlanMsg: '',
      closeSeatPlan: false,
      
      openSubjectChoice: false,
      closeSubjectChoice: false,

      openSif: false,
      closeSif: false,

      openStillInterested: false,
      closeStillInterested: false,
      stillInterested: false,
      showStillInterested: false,

      applicationInfoLoaded:false,
      file:'',
      personalStatus:'',
      activityLogs:null,
      languages:['Bangla','English'],
      agents:['Bkash','DBBL', 'Sonali Bank'],
      reloadBtn:false,
      applicationForm:{
        applicationId:'',
        unit:'',
        quota:'',
        quotaObj:null,
        question_language:'',
        medium:'',
        dominant_hand:'',
        exam_roll:'',
        bill_number:'',
        bill_status:'',
        amount:'',
        status:'',
        agent:'',
        paid_at:''
      },
      applicationInfo:{      
        status: '',
      },
      registrationForm:{
        name:'',
        father_name:'',
        mother_name:'',
        mobile:'',
        alternative_mobile:'',
        date_of_birth:'',
        gender:'',
        religion:'',
        bill_number:'',
        bill_status:'',
        amount:'',
        agent:'',
        paid_at:'',
        status:'',
        quota:'',
        quotaObj:null,
        medium:'',
        question_language:'',
        dominant_hand:'',
        userID:'',
        centerChoice1:'',
        centerChoice2:'',
        centerChoice3:''
      },
      /*pMedium:true,*/
      pQuota:true,
      
      pAlert:'',
      pAlertText:'',
      hscBoards:null,
      sscBoards:null,
      hscGroups:{
        sci:'Science',
        hum:'Humanities',
        bus:'Business Studies'
      },
      sscGroups:{
        sci:'Science',
        hum:'Humanities',
        bus:'Business Studies'
      },
      sscYear:'',
      hscYear:'',
      units:null,
      unitObj:null,
      quotas:null,
      photoEditable:0,
      photoEditBtnTxt:'Upload Photo',
      profileEditable:0,

      applicationApplicable:true,
      personTab:true,
      pQuotas:null,
      aQuotas:null,
      aQuotaObj:null,
      aQuota:false,
      photoInfo:{
        maxSize:0,
        width:0,
        height:0
      },
      applications:{},
      dew:false,
      paymentSlipInfo:{
        unit:'',
        bill_status:'',
        application_status:'',
        bill_number:'',
        amount:'',
        agent:'',
        paid_at:''
      },
      onlyPCQPersonal:false,
      onlyPCQApplication:false,
      dbblPaymentError: {
        reason: '',
        code: ''
      },
      correctionForm: {
        bill_number: '',
        amount: '',
        bill_status: '',
        agent: '',
        paid_at: ''
      },
      correctionApplied: false,
      isCorrectionLoading: false,
      paidCorrectionBills: [],

      isDownloadingPaySlip: false,
      paySlipProgresse: 'Preparing...',
      downloadingBills: {}
    }
  },
  computed: {
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    },
    
  },
  created() {
    this.getPersonalInfo(true);
    if(this.stillInterested)
      tabChange('interested');
  },
  mounted() {
    // Check for payment callback parameters
    const urlParams = new URLSearchParams(window.location.search);
    const paymentStatus = urlParams.get('payment');
    const paymentMethod = urlParams.get('method') || 'rocket'; // Default to rocket for backward compatibility

    // console.log('Payment Callback Detection:', { paymentStatus, paymentMethod });

    if (paymentStatus === 'success' && paymentMethod === 'rocket') {
      // console.log('Rocket Payment Success Detected');

      // Populate unified payment slip data for Rocket
      this.paymentSlipInfo.unit = urlParams.get('unit') || this.applicationForm.unit || '';
      this.paymentSlipInfo.bill_status = 'confirmed';
      this.paymentSlipInfo.application_status = 'paid';
      this.paymentSlipInfo.bill_number = urlParams.get('bill') || '';
      this.paymentSlipInfo.amount = urlParams.get('amount') || '';
      this.paymentSlipInfo.agent = 'DBBL Rocket';
      this.paymentSlipInfo.paid_at = urlParams.get('paid_at') || '';

      // console.log('Rocket Payment Data (unified):', this.paymentSlipInfo);

      // Show unified payment slip modal after DOM is ready
      this.$nextTick(() => {
        setTimeout(() => {
          // console.log('Showing Payment Slip Modal (Rocket)');
          this.$bvModal.show('applicationPaySlip');
        }, 300);
      });

      // Refresh profile data to show updated payment status
      this.getPersonalInfo(true);

    } else if (paymentStatus === 'failed' && paymentMethod === 'rocket') {
      // console.log('Rocket Payment Failure Detected');

      // Populate DBBL Rocket error data
      this.dbblPaymentError.reason = urlParams.get('reason') || 'Unknown error occurred';
      this.dbblPaymentError.code = urlParams.get('code') || '';

      // console.log('Rocket Payment Error:', this.dbblPaymentError);

      // Show Rocket failure modal after DOM is ready
      this.$nextTick(() => {
        setTimeout(() => {
          // console.log('Showing Rocket Failure Modal');
          this.$bvModal.show('rocketPaymentFailureModal');
        }, 300);
      });
    }
    // bKash payment callbacks should use method=bkash and will be handled separately
  },
  methods: {

    async downloadPaySlip(paymentReceipe) {

      const billNumber = paymentReceipe.bill_number

      // Skip if already downloading
      if (this.downloadingBills[billNumber]) return
      // if (this.isDownloadingPaySlip) {
      //   return
      // }

      //this.isDownloadingPaySlip = true
      this.$set(this.downloadingBills, billNumber, true)
      this.paySlipProgresse = 'Preparing...'

      try {
        await PayslipGenerator.generatePayslip(
          this.registrationForm,
          paymentReceipe,
          'PAID',
          (message, progress) => {
            this.paySlipProgresse = message
          },
          (error) => {
            console.error('Payment Receipet generation error:', error)
            this.$iziToast.error({
              title: 'Error',
              message: error.message || 'Failed to generate Payment Receipet. Please try again.'
            })
          }
        )

        // Success notification
        this.$iziToast.success({
          title: 'Success',
          message: 'Payment Receipet downloaded successfully!'
        })
      } catch (error) {
        console.error('Payment Receipet download error:', error)
        this.$iziToast.error({
          title: 'Error',
          message: error.message || 'Failed to download Payment Receipet. Please try again.'
        })
      } finally {
        //this.isDownloadingPaySlip = false
        this.$set(this.downloadingBills, billNumber, false)
        this.paySlipProgresse = 'Preparing...'
      }
    },

    updateInfoMargin(height) {
      // height from ImageCropUpload component
      this.infoMargin = height + 20; // add extra spacing
    },

    // work with ImageCropper, commenting
    /*
    async handlePhotoUpload(data) {
      // Assuming your backend returns a { url: '...' }
      if('status' in data){
        if(data.status=='success'){
           await this.getProfilePicture();
            this.$iziToast.success({
              /*title: 'Photo Upload',*/ /*
              message: 'Photo Uploaded Successfully!'
            });

        }else{
          this.$iziToast.success({
           /*title: 'Photo Upload',*/ /*
            message: 'Something Went Wrong When Updated!'
          });
        }
      }else{
        this.photoLink = data.url
      }
    },
    */

    async handlePhotoUpload(data) {
      // Refresh profile picture if needed
      // console.log('pdata',data);
      await this.getProfilePicture();

      // Optional: handle extra data
      if(data.status && data.status == "success" && data.url){
        //console.log(data.url)
        this.photoLink = data.url;
      }
    },

    async handleSignatureUpload(data) {
      // Refresh profile picture if needed
      //console.log('pdata',data);
      await this.getProfilePicture();

      // Optional: handle extra data
      if(data.status && data.status == "success" && data.url){
        //console.log(data.url)
        this.signatureLink = data.url;
      }
    },


    showAdmitCard(){
      if(!this.openAdmitCard){
        this.$iziToast.success({
            /*title: 'Admit Card',*/
            message: this.openAdmitCardMsg+this.openAdmitCardDate
        });
      }
    },

    checkingOnlyPCQ(quotaObject){
      /*console.log('quota');*/
      let allFalse = true;
      let PCQTrue = false;
      if(quotaObject['PCQ']){
        if(quotaObject['PCQ'].eligible){
          PCQTrue = true;
        }else{
          PCQTrue = false;
        }
      }
      for(let quota in quotaObject){
        if(quota!='PCQ'){
          if(quotaObject[quota].eligible){
            /*allFalse = true;*/
            allFalse = false;
          }
        }
      }
      if(PCQTrue && allFalse){
        return true;
      }
      return false;
    },

    applyPCQ(quotaObject){
      /*console.log('quota');*/
      let allFalse = true;
      let PCQTrue = false;
      if(quotaObject['PCQ']){
        if(quotaObject['PCQ'].eligible){
          PCQTrue = true;
        }else{
          PCQTrue = false;
        }
      }
      
      for(let quota in quotaObject){
        if(quota!='PCQ'){
          if(quotaObject[quota].eligible){
            allFalse = true;
            /*allFalse = false;*/
          }
        }
      }
      /*console.log(PCQTrue);*/
      if(PCQTrue || !allFalse){
        return true;      
      }
      return false;
    },

    isLoggedIn() {
      if (
        this.$store.state.auth.token &&
        this.$store.state.auth.expiresIn > this.$moment().unix()
      ) {
        return true
      } else {
        return false
      }
    },

    checkLoggedIn(){
      if(!this.isLoggedIn()){
        this.$router.push('home');
      }
    },

    showPaymentSlip(unit,bill_status,application_status,bill_number,agent,amount,paid_at=''){
      this.paymentSlipInfo.unit = unit;
      this.paymentSlipInfo.bill_status=bill_status;
      this.paymentSlipInfo.application_status=application_status;
      this.paymentSlipInfo.bill_number=bill_number;
      this.paymentSlipInfo.amount= amount;
      this.paymentSlipInfo.agent = agent;
      if(paid_at===null){
        this.paymentSlipInfo.paid_at = '';
      }else{
        this.paymentSlipInfo.paid_at = paid_at;
      }
      this.$bvModal.show('applicationPaySlip');
    },

    async generatePdf(){
      try {
        // Prepare receipt data from payment slip info
        const receiptData = prepareReceiptDataFromLegacy({
          name: this.registrationForm.name,
          father_name: this.registrationForm.father_name,
          userID: this.registrationForm.userID,
          unit: this.paymentSlipInfo.unit,
          bill_number: this.paymentSlipInfo.bill_number,
          amount: this.paymentSlipInfo.amount,
          paid_at: this.paymentSlipInfo.paid_at,
          agent: this.paymentSlipInfo.agent,
          status: 'PAID'
        });

        // Determine which preset to use based on payment method
        let preset = {};
        if (this.paymentSlipInfo.agent && this.paymentSlipInfo.agent.toLowerCase().includes('bkash')) {
          preset = RECEIPT_PRESETS.BKASH;
        } else if (this.paymentSlipInfo.agent && this.paymentSlipInfo.agent.toLowerCase().includes('rocket')) {
          preset = RECEIPT_PRESETS.ROCKET;
        } else if (this.paymentSlipInfo.agent && this.paymentSlipInfo.agent.toLowerCase().includes('surecash')) {
          preset = RECEIPT_PRESETS.SURECASH;
        } else {
          preset = RECEIPT_PRESETS.BANK;
        }

        // Generate and download PDF
        await generateReceipt(
          receiptData,
          preset,
          `cu_payment_slip_${this.paymentSlipInfo.bill_number}.pdf`
        );

        // console.log('Receipt downloaded successfully');
      } catch (error) {
        console.error('Error generating receipt:', error);
        this.$iziToast.error({message: 'Failed to generate receipt. Please try again.'});
      }
    },

    tabChange(name){
      if(name=='person'){
        this.personTab=true;
      }else{
        this.personTab=false;
      }
    },

    async getPersonalInfo(loadFirstTime=false){
      try{
        var data = await GET(GET_STUDENT_PROFILE_PERSONAL);
        // console.log("Profile::getPersonalInfo => ", data.data.data.personal_data);
      }catch(err){
        this.goToHome();
      }
      
      if(data.data.profileWindow){
        this.profileWindow = data.data.profileWindow;
      }else{
        this.profileWindow = 1;
      }

      this.openCall = data.data.openCall;
      this.closeCall = data.data.closeCall;
      
      this.openCorrection = data.data.openCorrection;
      this.closeCorrection = data.data.closeCorrection;
      
      this.openCorrectionPayment = data.data.openCorrectionPayment;
      this.closeCorrectionPayment = data.data.closeCorrectionPayment;
      
      this.closePaymentSlip = data.data.closePaymentSlip;
      
      this.openExam = data.data.openExam;
      this.closeExam = data.data.closeExam;
      
      this.openResult = data.data.openResult;
      this.closeResult = data.data.closeResult;
      
      this.openResultDate = data.data.openResultDate;
      this.openResultMsg = data.data.openResultMsg;
      
      this.openSeatPlan = data.data.openSeatPlan;
      this.closeSeatPlan = data.data.closeSeatPlan;
      this.openSeatPlanDate = data.data.openSeatPlanDate;
      this.openSeatPlanMsg = data.data.openSeatPlanMsg;
      
      this.openSubjectChoice = data.data.openSubjectChoice; 
      this.closeSubjectChoice = data.data.closeSubjectChoice; 

      this.openStillInterested = data.data.openStillInterested;
      this.closeStillInterested = data.data.closeStillInterested;
      this.showStillInterested = data.data.showStillInterested;
      this.stillInterested = data.data.stillInterested;
      
      this.registrationForm.name = data.data.data.personal_data.name;
      this.registrationForm.father_name = data.data.data.personal_data.fname;
      this.registrationForm.mother_name = data.data.data.personal_data.mname;
      this.registrationForm.mobile = data.data.data.personal_data.mobile;
      this.registrationForm.alternative_mobile = data.data.data.personal_data.user.alternative_mobile;
      this.registrationForm.gender = data.data.data.personal_data.gender;
      this.registrationForm.religion = data.data.data.personal_data.religion;
      this.registrationForm.date_of_birth = data.data.data.personal_data.dob;
      this.registrationForm.userID = data.data.data.personal_data.user.username;
      
      this.registrationForm.centerChoice1 = data.data.data.personal_data.centers[0];
      this.registrationForm.centerChoice2 = data.data.data.personal_data.centers[1];
      this.registrationForm.centerChoice3 = data.data.data.personal_data.centers[2];

      this.photoInfo.maxSize = data.data.data.photo_data.max_size;
      this.photoInfo.width = data.data.data.photo_data.width;
      this.photoInfo.height = data.data.data.photo_data.height;
      
      if(data.data.data.personal_data.medium==null || data.data.data.personal_data.medium==''){
        this.registrationForm.medium = '';
        this.registrationForm.dominant_hand = '';
        /* this.pMedium = true;*/
        this.pQuota = true;

      }else{
        this.registrationForm.medium = data.data.data.personal_data.medium;
        this.registrationForm.dominant_hand = data.data.data.personal_data.dominant_hand;
        /* this.pMedium = false; */
        this.pQuota = false;
      }

      let pPhoto = data.data.data.personal_data.photo;
      let pSignature = data.data.data.personal_data.signature;
      if(data.data.data.latest_bill.data){
        const billNumber = data.data.data.latest_bill.data.bill_number;
        const billAmount = data.data.data.latest_bill.data.fee;
        const billStatus = data.data.data.latest_bill.data.status;

        // Check if it's a correction bill (starts with '9')
        if(billNumber && billNumber.toString().startsWith('9')) {
          // Populate correction form
          this.correctionForm.bill_number = billNumber;
          this.correctionForm.amount = billAmount;
          this.correctionForm.bill_status = billStatus;
          this.correctionApplied = true;
        } else {
          // Regular admission bill
          this.registrationForm.bill_number = billNumber;
          this.registrationForm.amount = billAmount;
          this.registrationForm.bill_status = billStatus;
        }
      }
      this.registrationForm.gender=this.registrationForm.gender;
      if(data.data.data.personal_data.gender){
        if(this.registrationForm.gender=='FEMALE'){
          this.photoLink = process.env.VUE_APP_API_URL+'/dist/img/avatar-female.png';
        }else{
          this.photoLink = process.env.VUE_APP_API_URL+'/dist/img/avatar-male.png';
        }
      }else{
          this.photoLink = process.env.VUE_APP_API_URL+'/dist/img/avatar-male.png';
      }
      
      /*console.log('getPersonalInfo => ',JSON.parse(data.data.data.personal_data.quota), JSON.parse(data.data.data.quota));*/
      if(data.data.data.personal_data.quota!=null && data.data.data.personal_data.quota!=""){
        this.pQuotas = Object.keys(JSON.parse(data.data.data.personal_data.quota));
        this.registrationForm.quotaObj = JSON.parse(data.data.data.personal_data.quota);
      }else{
        this.registrationForm.quotaObj = data.data.data.quota;
        this.pQuotas = Object.keys(data.data.data.quota);
        /*this.pQuotas = data.data.data.quota;
         for (let x in this.pQuotas) {
           this.registrationForm.quotaObj[this.pQuotas[x]].subQuotaName = '';
         }*/
      }
     
      this.photoEditable = data.data.data.photo_edit ? 1 : 0;
      if(data.data.data.photo_message!=null && data.data.data.photo_message!=''){
        this.photoEditBtnTxt = data.data.data.photo_message;
      }else{
        if(pPhoto){
          this.hasPhoto = true;
          this.photoLink = pPhoto;
        }
      }

      if(data.data.data.signature_message==null || data.data.data.signature_message==''){
        this.signatureLink = pSignature;
      }

      this.profileEditable = data.data.data.profile_edit ? 1 : 0;
      /*this.units = data.data.data.units;*/
      this.unitObj = data.data.data.units;
      this.units = Object.keys(data.data.data.units);
      
      this.applicationForm.unit = this.units[0];
      this.onlyPCQPersonal = this.checkingOnlyPCQ(this.registrationForm.quotaObj);
      if(loadFirstTime){
        this.getApplicationInfo();
        this.timeoutForLoading();
      }
      this.getUnitValues();

      /*this.saveProfile = !this.photoEditable && !this.profileEditable;*/
      this.saveProfile = this.hasPhoto && !this.profileEditable;
      /*console.log('getPersonalInfo => ', this.hasPhoto, this.saveProfile, this.photoEditable, this.profileEditable);*/

      // Load paid correction bills if loadFirstTime
      if(loadFirstTime){
        this.getPaidCorrectionBills();
      }
    },
    
    async getProfilePicture(){
      var data = await GET(GET_STUDENT_PROFILE_PERSONAL);
      let pPhoto = '';
      let pSignature='';
      if(data.data.data.personal_data.photo){
        pPhoto = data.data.data.personal_data.photo;
      }

      if(data.data.data.personal_data.signature){
        pSignature = data.data.data.personal_data.signature;
      }
      
      this.photoEditable = data.data.data.photo_edit ? 1 : 0;
      this.profileEditable = data.data.data.profile_edit ? 1 : 0;
      if(data.data.data.photo_message!=null && data.data.data.photo_message!=''){
        this.photoEditBtnTxt = data.data.data.photo_message;
      }else{
        if(pPhoto!=''){
          this.hasPhoto = true;
          this.photoLink = pPhoto;
          this.photoEditBtnTxt = 'Upload Photo';
        }
      }

      if(pSignature!=''){
        this.signatureLink = pSignature;
      }
    },
    
    async getApplicationInfo(){
      let data = await GET(GET_STUDENT_PROFILE_APPLICATION);
      /*console.log('getApplicationInfo', data);*/
      this.applications = data.data.applications;
      this.applicationInfoLoaded = true;
    },

    async getHSCBoard(){
      var data = await GET(GET_HSC_BOARDS);
      this.hscBoards = data.data;
      this.getSSCBoard();
      this.getYears();
    },

    async getSSCBoard(){
      var data = await GET(GET_SSC_BOARDS);
      this.sscBoards = data.data;
    },

    async getYears(){
      var data = await GET(GET_YEARS);
      this.sscYear = data.data.ssc_year;
      this.hscYear = data.data.hsc_year;
    },

    async getUnits(){
      var data = await GET(GET_UNITS);
      /*console.log("getUnits", data);*/
      this.unitObj = data.data;
      this.units = Object.keys(data.data);
      this.applicationForm.unit = this.units[0];
      /*this.getQuotas();*/
      await this.getUnitValues();
    },

    /*Get Application by Unit*/
    async getUnitValues(storeInApplications=false){
      
      // console.log("getUnitValues :: ", this.unitObj[this.applicationForm.unit]);
      
      /* if already has values in this application set default values*/
      if(this.unitObj[this.applicationForm.unit]) {
        this.onApplicationLoading = true;
        
        this.openCall = false;
        this.closeCall = false;
        
        this.openCallPayment = false;
        this.closeCallPayment = false;
        
        this.openCorrectionPayment = false;
        this.closeCorrectionPayment = false;
        
        this.openAdmitCard = false;
        this.openAdmitCardDate = '';
        this.openAdmitCardMsg = '';
        this.closeAdmitCard = false;
        this.closeAdmitCardDate = '';
        this.closeAdmitCardMsg = '';
        
        this.openPaymentSlip = false;
        this.closePaymentSlip = false;
        
        this.openExam = false;
        this.closeExam = false;
        
        this.openResult = false;
        this.openResultDate = '';
        this.openResultMsg = '';
        this.closeResult = false;
        
        this.openSeatPlan = false;
        this.openSeatPlanDate = '';
        this.openSeatPlanMsg = '';
        this.closeSeatPlan = false;
        
        this.openSubjectChoice = false;
        this.closeSubjectChoice = false;
        
        this.openSif = false;
        this.closeSif = false;
        
        this.applicationInfo.status = '';

        this.applicationForm.bill_number = '';
        this.applicationForm.amount = '';
        this.applicationForm.bill_status = '';
        this.applicationForm.exam_roll = '';
        this.applicationForm.quota = '';
        this.applicationForm.quotaObj = null;
        this.applicationForm.status = '';
        this.applicationForm.paid_at = '';
        this.aQuotas = null;
        this.aQuota=false;

        /*get application information from backend*/
        // console.log("calling GET_APPLICATION_BY_UNIT");
        try{
          var data = await GET(GET_APPLICATION_BY_UNIT+this.applicationForm.unit);
          
          // console.log("getUnitValues::GET_APPLICATION_BY_UNIT", data.data);
        
        }catch(e){
          this.applicationApplicable = false;
          this.$iziToast.error({
            message: 'Something went wrong. Please try again.'
          });
          this.onApplicationLoading = false;
          return false;
        }

        /*console.log('test', data);*/
        
        if(data.data.status != 'success'){
          this.applicationApplicable = false;
          if(data.data.msg){
            this.$iziToast.error({
                message: data.data.msg
            });
          }
          this.onApplicationLoading = false;
          return false;
        }
        
        this.openCall = data.data.openCall;
        this.closeCall = data.data.closeCall;
        
        this.openCallPayment = data.data.openCallPayment;
        this.closeCallPayment = data.data.closeCallPayment;
        
        this.openCorrectionPayment = data.data.openCorrectionPayment;
        this.closeCorrectionPayment = data.data.closeCorrectionPayment;
        
        this.openPaymentSlip = data.data.openPaymentSlip;
        this.closePaymentSlip = data.data.closePaymentSlip;
        
        this.openAdmitCard = data.data.openAdmitCard;
        this.openAdmitCardDate = data.data.openAdmitCardDate;
        this.openAdmitCardMsg = data.data.openAdmitCardMsg;
        
        this.closeAdmitCard = data.data.closeAdmitCard;
        
        this.openSeatPlan = data.data.openSeatPlan;
        this.openSeatPlanDate = data.data.openSeatPlanDate;
        this.openSeatPlanMsg = data.data.openSeatPlanMsg;
        this.closeSeatPlan = data.data.closeSeatPlan;
        
        this.openExam = data.data.openExam;
        this.closeExam = data.data.closeExam;

        this.openResult = data.data.openResult;
        this.openResultDate = data.data.openResultDate;
        this.openResultMsg = data.data.openResultMsg;
        this.closeResult = data.data.closeResult;
        
        this.openSubjectChoice = data.data.openSubjectChoice;
        this.closeSubjectChoice = data.data.closeSubjectChoice;

        this.openSif = data.data.openSif;
        this.closeSif = data.data.closeSif;
        
        this.applicationInfo.status = data.data.status;
        // console.log('getUnitValues : ', this.applicationInfo);

        this.aQuotaObj = data.data.data.quota;
        
        if(this.aQuotaObj['PCQ']){
          let pcqApplication = this.checkingOnlyPCQ(this.aQuotaObj);
          if(pcqApplication){
            this.onlyPCQApplication = true;
          }else{
            this.onlyPCQApplication = false;
          }        
        }else{
          this.onlyPCQApplication = false;
        }
       
        if((data.data.data.status=='applied' || data.data.data.status=='paid')||(data.data.data.status=='completed'||data.data.data.status=='canceled')){
          
          this.applicationForm.bill_number = data.data.data.bill_number;
          this.applicationForm.amount = data.data.data.fee;
          this.applicationForm.bill_status = data.data.data.bill_status;
          this.applicationForm.exam_roll = data.data.data.exam_roll;
          this.applicationForm.paid_at = data.data.data.paid_at;
          
          this.applicationForm.applicationId = data.data.data.id;
          this.applicationForm.status = data.data.data.status;
          if(data.data.data.agent){
            if(data.data.data.agent!=null){
              this.applicationForm.agent = data.data.data.agent;
            }
          }
          this.applicationApplicable = false;
        }
        else{
          if(this.onlyPCQApplication){
            if(!this.aQuotaObj['PCQ'].value){
              this.applicationApplicable = false;
            }else{
              this.applicationApplicable = true;
            }
          }else{
            this.applicationApplicable = true;
          } 
        }
        
        if(this.applicationForm.agent!=''){
          if(this.applicationForm.agent=='bkash'){
            this.iconLink=process.env.VUE_APP_API_URL+'dist/img/BKashIcon.svg';
          }else if(this.applicationForm.agent=='dbbl'){
            this.iconLink=process.env.VUE_APP_API_URL+'dist/img/rocket.png';
          }else if(this.applicationForm.agent=='surecash'){
            this.iconLink=process.env.VUE_APP_API_URL+'dist/img/surecash.jpeg';
          }
        }
        this.onApplicationLoading = false;
      }
      // console.log("Profile::getUnitValues=>", this.applicationApplicable, ' - ', this.applicationInfo);
      // console.log("applicationForm:: ", this.openAdmitCard, this.closeAdmitCard, this.applicationForm, data.data);
      
    },

    async getQuotas(){
      var data = await GET(GET_QUOTAS);
      this.registrationForm.quotaObj = data.data;
      this.pQuotas = Object.keys(data.data);
    },

    alertClose(alertName){
      if(alertName=='pAlert'){
        this.pAlertText = '';
        this.pAlert = '';
      }else if(alertName == 'mAlert'){
        this.mAlertText = '';
        this.mAlert = '';
      }else if(alertName == 'vAlert'){
        this.vAlertText = '';
        this.vAlert = '';
      }
    },
 
    async onSubmit() {
      // Form submission already prevented by .prevent modifier in ProfilePersonal component 
      this.isPButtonLoading = true;
      this.isPButtonLoadingClass = 'btn info-btn btn-info radius-1';
      /*for (let x in this.pQuotas) {
        if(this.registrationForm.quotaObj[this.pQuotas[x]].value){
           if(this.registrationForm.quotaObj[this.pQuotas[x]]['sub-quota']!=null){
             this.registrationForm.quotaObj[this.pQuotas[x]]['sub-quota'][this.registrationForm.quotaObj[this.pQuotas[x]].subQuotaName] = true;
           }
         }
      }*/
      this.registrationForm.quota = JSON.stringify(this.registrationForm.quotaObj);

      //console.log('this.signatureLink',this.signatureLink)

      const IsPictureUploaded = this.photoLink !=null ? this.photoLink.includes(this.registrationForm.userID) : false;
      if(!IsPictureUploaded){
          this.$iziToast.error({
                  title: 'Picture Required',
                  message: 'Please upload your picture then save'
                });
          this.isPButtonLoading = false;
          return;
      }

      const IsSignatureUploaded = this.signatureLink !=null ? this.signatureLink.includes(this.registrationForm.userID) : false;
      if(!IsSignatureUploaded){
          this.$iziToast.error({
                  title: 'Signature Required',
                  message: 'Please upload your signature then save'
                });
          this.isPButtonLoading = false;
          return;
      }



      let response = await POST(UPDATE_STUDENT_PROFILE_PERSONAL, this.registrationForm);
      /*if(this.registrationForm.photo!=''){
         this.hasPhoto=true;
      }*/
      /*console.log("aftersubmission => ", response);*/
      
      if(response.status=='200'){
          let type = response.data.status;

          /*let code = response.data.code;*/
          if(type=='success'){
            
            let msg = response.data.msg;
            
            /*this.pAlert = 'alert-success';*/
            /*this.pAlertText = msg;*/
            
            this.pQuota = false;
            
            /*this.pMedium = false;*/
            
            this.getPersonalInfo();
            
            this.$iziToast.success({
                /*title: 'Success',*/
                message: msg
            });
          
            this.saveProfile = false;
          }else{
            this.saveProfile = true;
            let msg = response.data.msg;
              if(type=='info'){
                this.$iziToast.success({
                    /*title: 'Info',*/
                    message: msg
                });
              }else{
                  this.$iziToast.error({
                  /*title: 'Error',*/
                    message: msg
                });
              }
              /*if(code==914){
                   this.claimEnable = true;
               }else{
                   this.claimEnable = false;
               }
               this.pAlertText = msg;
               this.getPersonalInfo();*/
          }
      }
      this.isPButtonLoading = false;
    },

    async onApplicationSubmit() {
      this.isAButtonLoading = true;
      this.isAButtonLoadingClass = 'btn info-btn btn-info radius-1';
      /*this.applicationForm.quota = JSON.stringify(this.applicationForm.quotaObj);*/
      /*this.applicationForm.question_language = 'Bangla';*/
      let response = await POST(PROCESS_APPLICATION, this.applicationForm);
      /*console.log('onApplicationSubmit => ', response);*/
      
      if(response.status==200){
        /*console.log(response.data);*/

        let type = response.data.status;
          if(type=='success'){
            
            this.applicationApplicable = false;
            this.applicationForm.bill_number = response.data.data.bill_number;
            this.applicationForm.amount = response.data.data.fee;
            this.applicationForm.status = response.data.data.status;
            await this.getUnitValues();
            await this.getApplicationInfo();
            this.$iziToast.success({
                /*title: 'Success',*/
                message: "You have applied " + this.applicationForm.unit + ' Unit.'
            });
          }else{
            let msg = response.data.msg;
            /*console.log(response.data);*/
              if(type=='info'){
                this.$iziToast.success({
                    /*title: 'Info',*/
                    message: msg
                });
              }else{
                  this.$iziToast.error({
                  /*title: 'Error',*/
                    message: msg
                });
              }
          } 
        
      }else{
        this.$iziToast.error({
          /*title: 'Error',*/
            message: 'Someting went wrong.'
        });
      }
      this.isAButtonLoading = false;
    },

    /*Get Application by Unit*/
    async startBkashCheckoutService() {
      
      try {
        this.isPayButtonLoading = true;

        let data = await GET(BKASH_PAYMENT_GATEWAY + '?bill=' + this.applicationForm.bill_number);

        if(data.status==200) {
          let response = data.data;
          
          // console.log('Processing ... ', response);
        
          if(response.type=='success' && response.code=="bkashURL") 
            window.location.href = response.msg;  
            /*this.goForUrl('admission.sust.edu.bd');*/
          else {
            if(response.type=='success') 
              this.$iziToast.success({message: response.msg});
            else {
              if(response.type=='error') 
                this.$iziToast.error({message: response.msg});
              else {
                if(response.type=='info') 
                  this.$iziToast.info({message: response.msg});
                else {
                  if(response.type=='danger') 
                    this.$iziToast.danger({message: response.msg});
                }
              }
            }
          }
        }
        else 
          this.$iziToast.error({message: 'Unable to connect the payment gateway. contact with Helpdesk.'});
      } catch (err) {
        this.isPayButtonLoading = false;
      } finally {
        this.isPayButtonLoading = false;
      };
    },

    /**
     * Start DBBL Rocket Payment (Modern Spring Boot API Integration)
     * Rocket uses card_type = 6
     */
    async startDbblRocketPayment() {
      this.startDbblPayment(6);
    },

    /**
     * Start DBBL Nexus Payment (Visa/MasterCard)
     * Nexus uses card_type = 4
     * @deprecated Use startDbblVisaPayment or startDbblMasterCardPayment instead
     */
    async startDbblNexsusPayment() {
      this.startDbblPayment(4);
    },

    /**
     * Start DBBL Visa Payment
     * Visa uses card_type = 4
     */
    async startDbblVisaPayment() {
      this.startDbblPayment(4);
    },

    /**
     * Start DBBL MasterCard Payment
     * MasterCard uses card_type = 5
     */
    async startDbblMasterCardPayment() {
      this.startDbblPayment(5);
    },

    /**
     * Common DBBL payment initiation method
     * @param {number} card_type - 4 for Visa, 5 for MasterCard, 6 for Rocket
     */
    async startDbblPayment(card_type = 6) {
      try {
        this.isPayButtonLoading = true;

        // Determine payment method name based on card type
        let paymentMethod = 'DBBL';
        if (card_type == 4) {
          paymentMethod = 'DBBL Visa';
        } else if (card_type == 5) {
          paymentMethod = 'DBBL MasterCard';
        } else if (card_type == 6) {
          paymentMethod = 'DBBL Rocket';
        }

        // console.log(`Initiating ${paymentMethod} payment with card_type=${card_type}`);

        let data = await GET(DBBL_PAYMENT_GATEWAY + '?bill=' + this.applicationForm.bill_number + '&card_type=' + card_type);

        if (data.status == 200) {
          let response = data.data;

          // console.log(`${paymentMethod} Processing ... `, response);

          if (response.success && response.type == 'success' && response.code == "dbblGatewayURL") {
            // Redirect to DBBL gateway
            window.location.href = response.msg;
          } else {
            // Show appropriate toast message
            if (response.type == 'success') {
              this.$iziToast.success({message: response.msg});
            } else if (response.type == 'error') {
              this.$iziToast.error({message: response.msg});
            } else if (response.type == 'info') {
              this.$iziToast.info({message: response.msg});
            } else if (response.type == 'warning') {
              this.$iziToast.warning({message: response.msg});
            } else {
              this.$iziToast.error({message: response.msg || 'Payment initialization failed'});
            }
          }
        } else {
          this.$iziToast.error({message: 'Unable to connect to DBBL payment gateway. Please contact Helpdesk.'});
        }
      } catch (err) {
        console.error('DBBL Payment Error:', err);
        this.$iziToast.error({message: 'An error occurred while initiating payment. Please try again.'});
      } finally {
        this.isPayButtonLoading = false;
      }
    },

    async startDBBLService() {
      // Legacy method - redirects to new implementation
      this.startDbblRocketPayment();
    },


    /**
     * Close payment modal and clear URL parameters
     */
    closePaymentModal() {
      // Hide payment modals
      this.$bvModal.hide('applicationPaySlip');
      this.$bvModal.hide('rocketPaymentFailureModal');

      // Clear URL parameters
      const url = new URL(window.location.href);
      url.searchParams.delete('payment');
      url.searchParams.delete('method');
      url.searchParams.delete('bill');
      url.searchParams.delete('amount');
      url.searchParams.delete('txn_id');
      url.searchParams.delete('approval');
      url.searchParams.delete('paid_at');
      url.searchParams.delete('reason');
      url.searchParams.delete('code');
      url.searchParams.delete('already_paid');

      // Update URL without reloading
      window.history.replaceState({}, document.title, url.pathname);

      // Refresh profile data to show updated status
      this.getPersonalInfo(true);
    },

    /**
     * Retry payment after failure
     */
    retryPayment() {
      // Close the Rocket failure modal
      this.$bvModal.hide('rocketPaymentFailureModal');

      // Clear URL parameters
      const url = new URL(window.location.href);
      url.searchParams.delete('payment');
      url.searchParams.delete('method');
      url.searchParams.delete('reason');
      url.searchParams.delete('code');
      window.history.replaceState({}, document.title, url.pathname);

      // Retry DBBL Rocket payment
      this.startDbblRocketPayment();
    },

    async startSonaliService(){
      
      this.onApplicationLoading = true;

      // console.log("call Sonali :: ", this.applicationForm);

      try {
        this.isLoading = true;
        let response = await POST(
          'https://spg.sblesheba.com:6314/api/v3/spgservice/CreatePaymentRequest', 
          this.applicationForm
        );
      } catch (err) {
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }

      // console.log("response Sonali :: ", response);

      this.onApplicationLoading = false;

    },

    onApplicationClaim(){
      this.$bvModal.show('applicationClaimModal');
    },

    onApplicationPaySlip(){
      this.showPaymentSlip(this.applicationForm.unit,this.applicationForm.bill_status,this.applicationForm.status,this.applicationForm.bill_number,this.applicationForm.agent,this.applicationForm.amount,this.applicationForm.paid_at);
    },

    onApplicationCancel(){
    },

    onReload(){
      this.reloadBtn = false;
      window.location.reload();
    },

    goToHome(){
      window.location = '/'; 
    },

    async onApplyForCorrection() {
      this.isCorrectionLoading = true;
      try {
        let response = await GET(GET_REQUEST_CHANGE);

        if (response.status == 200) {
          let type = response.data.status;
          let msg = response.data.msg;

          if (type == 'success') {
            this.correctionApplied = true;
            this.correctionForm.bill_number = response.data.data.bill_number;
            this.correctionForm.amount = response.data.data.fee;
            this.correctionForm.bill_status = response.data.data.status;

            this.$iziToast.success({
              message: msg
            });
          } else {
            if (type == 'info') {
              this.$iziToast.info({
                message: msg
              });
            } else {
              this.$iziToast.error({
                message: msg
              });
            }
          }
        }
      } catch (error) {
        this.$iziToast.error({
          message: 'Something went wrong. Please try again.'
        });
      } finally {
        this.isCorrectionLoading = false;
      }
    },

    async getPaidCorrectionBills() {
      try {
        let response = await GET(GET_PAID_CORRECTION_BILLS);
        if (response.status == 200 && response.data.status == 'success') {
          this.paidCorrectionBills = response.data.data || [];
        }
      } catch (error) {
        console.error('Error fetching paid correction bills:', error);
        this.paidCorrectionBills = [];
      }
    },

    onCorrectionPaySlip(bill_number, agent, amount, paid_at) {
      // Reuse the existing showPaymentSlip method with 'CO' as unit
      this.showPaymentSlip('CO', 'confirmed', 'paid', bill_number, agent, amount, paid_at);
    },

    async startBkashCorrectionPayment() {
      try {
        this.isPayButtonLoading = true;

        let data = await GET(BKASH_PAYMENT_GATEWAY + '?bill=' + this.correctionForm.bill_number);

        if(data.status==200) {
          let response = data.data;

          if(response.type=='success' && response.code==="bkashURL")
            window.location.href = response.msg;
          else {
            if(response.type=='success')
              this.$iziToast.success({message: response.msg});
            else {
              if(response.type=='error')
                this.$iziToast.error({message: response.msg});
              else {
                if(response.type=='info')
                  this.$iziToast.info({message: response.msg});
                else {
                  if(response.type=='danger')
                    this.$iziToast.danger({message: response.msg});
                }
              }
            }
          }
        }
        else
          this.$iziToast.error({message: 'Unable to connect the payment gateway. contact with Helpdesk.'});
      } catch (err) {
        this.isPayButtonLoading = false;
      } finally {
        this.isPayButtonLoading = false;
      }
    },

    async startDbblRocketCorrectionPayment() {
      this.startDbblCorrectionPayment(6);
    },

    async startDbblVisaCorrectionPayment() {
      this.startDbblCorrectionPayment(4);
    },

    async startDbblMasterCardCorrectionPayment() {
      this.startDbblCorrectionPayment(5);
    },

    async startDbblCorrectionPayment(card_type = 6) {
      try {
        this.isPayButtonLoading = true;

        let paymentMethod = 'DBBL';
        if (card_type == 4) {
          paymentMethod = 'DBBL Visa';
        } else if (card_type == 5) {
          paymentMethod = 'DBBL MasterCard';
        } else if (card_type == 6) {
          paymentMethod = 'DBBL Rocket';
        }

        let data = await GET(DBBL_PAYMENT_GATEWAY + '?bill=' + this.correctionForm.bill_number + '&card_type=' + card_type);

        if (data.status == 200) {
          let response = data.data;

          if (response.success && response.type == 'success' && response.code == "dbblGatewayURL") {
            window.location.href = response.msg;
          } else {
            if (response.type == 'success') {
              this.$iziToast.success({message: response.msg});
            } else if (response.type == 'error') {
              this.$iziToast.error({message: response.msg});
            } else if (response.type == 'info') {
              this.$iziToast.info({message: response.msg});
            } else if (response.type == 'warning') {
              this.$iziToast.warning({message: response.msg});
            } else {
              this.$iziToast.error({message: response.msg || 'Payment initialization failed'});
            }
          }
        } else {
          this.$iziToast.error({message: 'Unable to connect to DBBL payment gateway. Please contact Helpdesk.'});
        }
      } catch (err) {
        console.error('DBBL Correction Payment Error:', err);
        this.$iziToast.error({message: 'An error occurred while initiating payment. Please try again.'});
      } finally {
        this.isPayButtonLoading = false;
      }
    },

    async executeRequestToChangePersonal(){
      let response = await GET(GET_REQUEST_CHANGE);
      /*console.log(response);*/
      if(response.status==200){
        /*console.log(response);*/
        let type = response.data.status;
        let msg = response.data.msg;
        if(type=='success'){
          this.dew = true;
          this.registrationForm.bill_number = response.data.data.bill_number;
          this.registrationForm.amount = response.data.data.fee;
          this.personalStatus = response.data.data.status;
          this.registrationForm.bill_status = response.data.data.status;
          this.$iziToast.success({
            message: msg
          });
          this.reloadBtn=true;
        }else{
          if(type=='info'){
            this.$iziToast.success({
              message: msg
            });
          }else{
            this.$iziToast.error({
              message: msg
            });
          }
        }
      }
      this.isPButtonLoading = false;
    },

    async onRequestToApplicationChange() {
      let response = await GET(GET_REQUEST_APPLICATION_CHANGE+this.applicationForm.applicationId);
      if(response.status==200){
        this.applicationForm.bill_number = response.data.data.bill_number;
        this.applicationForm.amount = response.data.data.amount;
        this.applicationForm.status = response.data.data.status;
      }      
    },

    async onRequestToFeePay() {
      // console.log(this.agent);

      let response = await GET(GET_REQUEST_APPLICATION_CHANGE+this.applicationForm.applicationId);
      if(response.status==200){
        this.applicationForm.bill_number = response.data.data.bill_number;
        this.applicationForm.amount = response.data.data.amount;
        this.applicationForm.status = response.data.data.status;
      }      
    },

    async imageUpload(){
      this.imageUploading = true;
      this.file = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append('photo', this.file);
      let response = await POST(UPLOAD_PHOTO, formData);
      if(response.status==200){
        if(response.data.status=='success'){
          /*this.getImgLink();*/
          await this.getProfilePicture();
          this.$iziToast.success({
            /*title: 'Photo Upload',*/
            message: 'Photo Uploaded Successfully!'
          });
          }else{
            /*console.log(response.data.message.photo);*/

            document.getElementById("actual-btn").value = '';
            let i;
            let eMsg = '';
            for (i = 0; i < response.data.message.photo.length; i++) {
              eMsg += response.data.message.photo[i];
            }
            /*this.getPersonalInfo();*/
            this.$iziToast.error({
             /*title: 'Photo Upload',*/
              message: eMsg
            });
          }        
        /*this.photoLink = process.env.VUE_APP_API_URL + response.data;*/
        /*this.registrationForm.photo = response.data;*/
      }else{
        this.$iziToast.success({
         /*title: 'Photo Upload',*/
          message: 'Something Went Wrong When Updated!'
        });
      }
      this.imageUploading = false;
    },
    
    goForUrl(url) {
      this.$router.replace(url)
    },

    topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },

    timeoutForLoading() {
      if (this.firstTimeLoad) {
        this.$nextTick(() => {
          setTimeout(
            function() {
              this.loading = false
            }.bind(this),
            2000
          )
        })
      }
      this.firstTimeLoad = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pdf-app{
  width:500px;
  height:500px;
}
.middle-center {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.employee{
  -webkit-box-shadow: unset;
  box-shadow: unset;
}

.team-sec.team-grid .employee {
  padding:0px !important;
}
.d-flex{
  /* padding:10px; */
  margin:10px;
  -webkit-box-shadow: 1px 0 15px 2px #f3f3f3;
  box-shadow: 1px 0 15px 2px #f3f3f3;
}
.loader {
  margin-top: 20%;
}

/* .form-file-text{
  
} */
.custom-file-label{
  text-align: left;
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */

.header {
  /* background-image: url('../../../theme-assets/header-banner.jpg'); */
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  display: table;
  width: 100%;
  height: 100vh;
}
.img-fluid{
  max-width:100%;
}
.header .overlay {
  background-color: rgba(0, 0, 0, 0.47);
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.header .header-content-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.header .header-content-wrapper .header-content {
  /* background-image: url('../../../theme-assets/header_title_bg.png'); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  color: #292b5b;
  font-weight: 600;
  padding: 5px 5px;
}

.header-content .header-logo {
  margin-bottom: 15px;
  width: 125px;
}

.header-content .welcome-text {
  padding: 0px 95px;
  font-weight: bold;
  color: white;
}

.header-content .highlight {
  /* background-image: url('../../assets/header_title_bg_2.png'); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  color: #f9f142;
  display: block;
  font-size: 35px;
  margin-top: 15px;
  padding: 20px 0px;
}

.header .overlay-2 {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.4);
  color: #fff;
  font-weight: 700;
  letter-spacing: 1px;
  padding-top: 10px;
}

.header .overlay-2 .highlight {
  color: #fbf574;
  font-size: 28px;
  font-weight: 500;
}

.header .overlay-2 img {
  position: absolute;
  right: 10%;
  bottom: 0;
}

/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}
.header .center-text {
    height: unset;
}
.header .bg {
    height: unset;
}
.header[data-v-af5e64f8] {
    
    height: unset;
}
* {
   box-sizing: border-box;
}
.profile-tab-content .theme-card {
  border: none !important;
}
 @-webkit-keyframes ticker {
   0% {
     -webkit-transform: translate3d(0, 0, 0);
     transform: translate3d(0, 0, 0);
     visibility: visible;
  }
   100% {
     -webkit-transform: translate3d(-100%, 0, 0);
     transform: translate3d(-100%, 0, 0);
  }
}
 @keyframes ticker {
   0% {
     -webkit-transform: translate3d(0, 0, 0);
     transform: translate3d(0, 0, 0);
     visibility: visible;
  }
   100% {
     -webkit-transform: translate3d(-100%, 0, 0);
     transform: translate3d(-100%, 0, 0);
  }
}
 .ticker-wrap {
   /* position: fixed; */
   /* bottom: 0; */
     position: relative;
   width: 100%;
   overflow: hidden;
   height: 3rem;
   background-color: rgba(0, 0, 0, 0.9);
   padding-left: 100%;
   box-sizing: content-box;
}
 .ticker-wrap .ticker {
   display: inline-block;
   height: 3rem;
   line-height: 3rem;
   white-space: nowrap;
   padding-right: 100%;
   box-sizing: content-box;
   -webkit-animation-iteration-count: infinite;
   animation-iteration-count: infinite;
   -webkit-animation-timing-function: linear;
   animation-timing-function: linear;
   -webkit-animation-name: ticker;
   animation-name: ticker;
   -webkit-animation-duration: 30s;
   animation-duration: 30s;
}
 .ticker-wrap .ticker__item {
   display: inline-block;
   padding: 0 1.5rem;
   font-size: 1.5rem;
   color: white;
}
.cart-section tbody tr td {
    min-width: 140px;
}
table{
    overflow: scroll;
}
.d-flex[data-v-255a7e23] {
    /* padding: 10px; */
    /* margin: 10px; */
    -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3;
}

.tabs{
  width: 100% ;
}

.nav-tabs .nav-link {
  font-size: 15px;
  /* font-size: calc(15px + (14 - 13) * ((100vw - 300px) / (1920 - 300))); */
}
#labelImgBtn{
  max-width: 100%;
  font-weight: bold;
  background-color: #624e71;
  color: white;
  padding: 0.5rem;
  margin: auto;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
#labelImgBtn:hover{
  background-color: #78618a;
}
.b-avatar .b-avatar-text {
    text-transform: uppercase;
    white-space: nowrap;
    color: white;
}

@media screen and (min-width: 469px) {
  .btn-right {
    float: right;
  }
}
@media screen and (min-width: 768px) {
  .p-quota-div {
    width: 13%;
  }
}

/* Payment Card Hover Effects */
.payment-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.15) !important;
  border-color: #3498db !important;
}

.payment-card:active {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.12) !important;
}

/* Responsive adjustments for payment cards */
@media screen and (max-width: 768px) {
  .payment-card {
    min-height: 120px !important;
    padding: 15px 10px !important;
  }

  .payment-card-logo img {
    height: 50px !important;
  }

  .payment-card-title {
    font-size: 12px !important;
  }
}

@media screen and (max-width: 576px) {
  .payment-options-container h5 {
    font-size: 16px !important;
    margin-bottom: 20px !important;
  }

  .payment-card {
    min-height: 110px !important;
    padding: 12px 8px !important;
  }

  .payment-card-logo img {
    height: 45px !important;
  }

  .payment-card-title {
    font-size: 11px !important;
    margin-top: 5px !important;
  }
}

/* Modern Tab Styling */
.modern-tabs-wrapper {
  width: 100%;
}

.modern-tab-link {
  background: #f8fafc !important;
  border: 2px solid #e2e8f0 !important;
  border-radius: 10px !important;
  padding: 12px 20px !important;
  margin-right: 8px !important;
  margin-bottom: 8px !important;
  color: #64748b !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.modern-tab-link:hover {
  background: #f1f5f9 !important;
  border-color: #a5b4fc !important;
  color: #4f46e5 !important;
  transform: translateY(-2px);
}

.modern-tab-link.active {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%) !important;
  border-color: #4f46e5 !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.modern-tab-link i {
  font-size: 16px;
}

.tab-text {
  font-weight: 600;
}

.modern-tab-content {
  /* padding: 20px 15px !important; */
  background: transparent !important;
  border: none !important;
}

/* Profile wrapper */
.modern-profile-wrapper {
  background: #f8fafc;
  min-height: 100vh;
}

.modern-profile-wrapper .d-flex{
  padding: 10px !important;
}
/* Modern Application Status Table Styling */
.modern-application-status-wrapper {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  /* padding: 20px; */
}

.status-table-header {
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e0e7ff;
}

.status-table-title {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-table-title i {
  color: #6366f1;
  font-size: 22px;
}

.status-table-subtitle {
  font-size: 13px;
  color: #6c757d;
  margin: 5px 0 0 32px;
}

.modern-table-wrapper {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.modern-status-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: white;
}

.modern-status-table thead tr {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.modern-status-table thead th {
  padding: 16px 20px;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.modern-status-table thead th i {
  margin-right: 8px;
  opacity: 0.9;
}

.modern-status-table tbody tr {
  transition: all 0.3s ease;
  border-bottom: 1px solid #f1f5f9;
}

.modern-status-table tbody tr:hover {
  background-color: #f8faff;
  transform: scale(1.01);
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);
}

.modern-status-table tbody tr:last-child {
  border-bottom: none;
}

.modern-status-table tbody td {
  padding: 18px 20px;
  font-size: 14px;
  color: #334155;
  vertical-align: middle;
}

.unit-badge {
  display: inline-block;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 6px rgba(99, 102, 241, 0.3);
}

.bill-number {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #475569;
  background: #f1f5f9;
  padding: 6px 12px;
  border-radius: 6px;
  display: inline-block;
}

.payment-method-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f0fdf4;
  color: #166534;
  padding: 6px 14px;
  border-radius: 8px;
  font-weight: 500;
  border: 1px solid #bbf7d0;
}

.modern-slip-button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.3);
}

.modern-slip-button:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
}

.modern-slip-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.3);
}

.modern-slip-button i {
  font-size: 14px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px !important;
}

.empty-state-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.empty-state-content i {
  font-size: 48px;
  color: #cbd5e1;
}

.empty-state-content p {
  font-size: 16px;
  color: #64748b;
  margin: 0;
  font-weight: 500;
}

/* Responsive Design for Application Status Table */
@media screen and (max-width: 992px) {
  .modern-status-table thead th {
    padding: 14px 16px;
    font-size: 13px;
  }

  .modern-status-table tbody td {
    padding: 16px 16px;
    font-size: 13px;
  }

  .unit-badge {
    font-size: 13px;
    padding: 5px 14px;
  }

  .modern-slip-button {
    padding: 8px 16px;
    font-size: 12px;
  }
}

@media screen and (max-width: 768px) {
  .modern-application-status-wrapper {
    padding: 15px;
  }

  .status-table-title {
    font-size: 18px;
  }

  .status-table-subtitle {
    font-size: 12px;
  }

  .modern-status-table thead th {
    padding: 12px 10px;
    font-size: 11px;
  }

  .modern-status-table thead th i {
    display: none;
  }

  .modern-status-table tbody td {
    padding: 14px 10px;
    font-size: 12px;
  }

  .unit-badge {
    font-size: 12px;
    padding: 4px 10px;
  }

  .bill-number {
    font-size: 11px;
    padding: 4px 8px;
  }

  .payment-method-badge {
    font-size: 11px;
    padding: 4px 10px;
  }

  .modern-slip-button {
    padding: 6px 12px;
    font-size: 11px;
  }

  .modern-slip-button span {
    display: none;
  }
}

/* Card-based layout for mobile */
@media screen and (max-width: 576px) {
  .modern-table-wrapper {
    border: none;
  }

  .modern-status-table thead {
    display: none;
  }

  .modern-status-table tbody tr {
    display: block;
    margin-bottom: 15px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background: white;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }

  .modern-status-table tbody tr:hover {
    transform: none;
  }

  .modern-status-table tbody td {
    display: block;
    text-align: left;
    padding: 12px 15px;
    border-bottom: 1px solid #f1f5f9;
  }

  .modern-status-table tbody td:last-child {
    border-bottom: none;
  }

  .modern-status-table tbody td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #64748b;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: block;
    margin-bottom: 6px;
  }

  .unit-badge,
  .bill-number,
  .payment-method-badge,
  .modern-slip-button {
    display: inline-flex;
    width: auto;
  }

  .modern-slip-button {
    width: 100%;
    justify-content: center;
  }
}


</style>